(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charoux-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Shopify's customer form takes `contact[tags]` as a single comma-separated string,
     * so the interest checkboxes are collected into one hidden field on submit rather
     * than posted as repeated params (which Shopify would not merge).
     */
    const bind = (form) => {
      if (form.dataset.charouxTagsBound) return;
      form.dataset.charouxTagsBound = 'true';

      const hidden = form.querySelector('[data-charoux-tags]');
      if (!hidden) return;
      const base = hidden.value;

      const sync = () => {
        const chosen = [...form.querySelectorAll('[data-charoux-tag]')]
          .filter((cb) => cb.checked)
          .map((cb) => cb.value);
        hidden.value = [base, ...chosen].filter(Boolean).join(',');
      };

      form.querySelectorAll('[data-charoux-tag]').forEach((cb) => {
        cb.addEventListener('change', sync);
      });
      sync();
    };

    document.querySelectorAll('.charoux-footer__form').forEach(bind);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.charoux-footer__form').forEach(bind);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charoux-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (header) => {
      if (header.dataset.charouxHeaderBound) return;
      header.dataset.charouxHeaderBound = 'true';

      const burger = header.querySelector('.charoux-header__burger');
      const drawer = header.querySelector('.charoux-header__drawer');
      if (!burger || !drawer) return;

      const setOpen = (open) => {
        drawer.hidden = !open;
        burger.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
        if (open) {
          const first = drawer.querySelector('a');
          if (first) first.focus();
        }
      };

      burger.addEventListener('click', () => {
        setOpen(drawer.hidden);
      });

      drawer.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (drawer.hidden) return;

        if (event.key === 'Escape') {
          setOpen(false);
          burger.focus();
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = [burger, ...drawer.querySelectorAll('a[href], button:not([disabled])')];
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (event.shiftKey && (active === first || !focusable.includes(active))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      });

      const desktop = window.matchMedia('(min-width: 750px)');
      desktop.addEventListener('change', (event) => {
        if (event.matches && !drawer.hidden) setOpen(false);
      });

      header.charouxIsDrawerOpen = () => !drawer.hidden;
    };

    const setupDropdowns = (header) => {
      if (header.dataset.charouxDropdownsBound) return;
      header.dataset.charouxDropdownsBound = 'true';

      const items = [...header.querySelectorAll('[data-charoux-dropdown]')];
      if (!items.length) return;

      const panelFor = (item) => item.querySelector('.charoux-header__dropdown');
      const triggerFor = (item) => item.querySelector('.charoux-header__nav-trigger');

      const close = (item) => {
        const panel = panelFor(item);
        const trigger = triggerFor(item);
        if (!panel || !trigger) return;
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };

      const closeAll = (except) => {
        items.forEach((item) => {
          if (item !== except) close(item);
        });
      };

      items.forEach((item) => {
        const panel = panelFor(item);
        const trigger = triggerFor(item);
        if (!panel || !trigger) return;

        trigger.addEventListener('click', () => {
          const isOpen = !panel.hidden;
          closeAll(item);
          panel.hidden = isOpen;
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });

      document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-charoux-dropdown]')) closeAll();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openItem = items.find((item) => triggerFor(item)?.getAttribute('aria-expanded') === 'true');
        if (!openItem) return;
        close(openItem);
        triggerFor(openItem).focus();
      });
    };

    const setupDrawerAccordions = (header) => {
      if (header.dataset.charouxDrawerAccordionsBound) return;
      header.dataset.charouxDrawerAccordionsBound = 'true';

      header.querySelectorAll('.charoux-header__drawer-trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!panel) return;
          const isOpen = !panel.hidden;
          panel.hidden = isOpen;
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    };

    const setupScroll = (header) => {
      const behaviour = header.dataset.scrollBehaviour;
      const root = document.documentElement;
      if (behaviour !== 'sticky' && behaviour !== 'reveal') return;

      root.dataset.charouxHeader = behaviour;
      if (behaviour !== 'reveal') return;

      const SQUEEZE = window.matchMedia('(min-width: 990px)');
      const scrollContainer = () =>
        (SQUEEZE.matches ? document.querySelector('.page-wrapper') : null) ??
        document.scrollingElement ??
        document.documentElement;
      const scrollEventTarget = () =>
        (SQUEEZE.matches ? document.querySelector('.page-wrapper') : null) ?? document;

      const threshold = parseInt(header.dataset.revealThreshold, 10) || 0;
      let last = scrollContainer().scrollTop;
      let ticking = false;

      const update = () => {
        ticking = false;
        const y = scrollContainer().scrollTop;
        const delta = y - last;

        if (header.charouxIsDrawerOpen && header.charouxIsDrawerOpen()) {
          root.dataset.charouxScroll = 'up';
          last = y;
          return;
        }

        if (y <= threshold) {
          root.dataset.charouxScroll = 'top';
        } else if (delta > 4) {
          root.dataset.charouxScroll = 'down';
        } else if (delta < -4) {
          root.dataset.charouxScroll = 'up';
        }

        if (Math.abs(delta) > 4) last = y;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      let bound = scrollEventTarget();
      bound.addEventListener('scroll', onScroll, { passive: true });

      SQUEEZE.addEventListener('change', () => {
        bound.removeEventListener('scroll', onScroll);
        bound = scrollEventTarget();
        bound.addEventListener('scroll', onScroll, { passive: true });
        last = scrollContainer().scrollTop;
        update();
      });

      update();
    };

    document.querySelectorAll('.charoux-header').forEach((header) => {
      setup(header);
      setupScroll(header);
      setupDropdowns(header);
      setupDrawerAccordions(header);
    });

    document.addEventListener('shopify:section:load', (event) => {
      document.documentElement.dataset.charouxScroll = 'top';
      event.target.querySelectorAll('.charoux-header').forEach((header) => {
        setup(header);
        setupScroll(header);
        setupDropdowns(header);
        setupDrawerAccordions(header);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
